<template>
  <div class='bg-gradient-to-b from-pink-100 to-pink-50 min-h-screen flex items-center justify-center'>
    <div v-if='!isAuthorized'>
      <moderator-logout />
    </div>
    <div v-else class='w-full text-xl'>
      <div class='absolute inset-0 p-11'>
        <div class='w-full h-full bg-gray-50 rounded-lg shadow'>
          <div class='flex flex-row justify-evenly items-center p-11 h-screen'>
            <div class='flex flex-col justify-between items-start self-center'>
              <div
                @click='goToModeratorHome()' 
                class='cursor-pointer'>
                <img
                  :src='logoUrl'
                  class='h-6'>
              </div>
              <h1 class='text-6xl font-bold py-4'>
                {{ this.selectedSession.title }}
              </h1>
              <span
                class='text-5xl'>
                {{formattedTimeString(selectedSession.scheduledStartTime)}} - {{formattedTimeString(selectedSession.scheduledEndTime)}}
              </span>
              <div class='py-11'>
                <button
                  class='logout-button w-full lg:w-64 uppercase border mt-4 bg-pink-500 text-gray-50 px-8 py-4 text-center rounded-md hover:shadow-md cursor-pointer'
                  @click='startVoting'>
                  <div class='flex flex-row items-center justify-center'>
                    Start
                    <arrow-narrow-right-icon class='h-4' /> 
                  </div>
                </button>
              </div>
            </div>
            <div class='h-22'>
              <qrcode-vue
                :value='dynamicLink'
                size='600'
                version='4'
                background='transparent'
                foreground='#4B5563'
                render-as='svg' />
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModeratorLogout from '@/views/gbcc2025/ModeratorLogout.vue'
import DynamicLinkHelper from '@/utils/dynamic-link-helper'
import { mapState, mapGetters, mapActions }  from 'vuex'
import { ArrowNarrowRightIcon } from 'vue-tabler-icons'
import QrcodeVue from 'qrcode.vue'
import dayjs from 'dayjs'
import utc      from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone' 
dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  name: 'ModeratorStart',
  components: {
    ArrowNarrowRightIcon,
    QrcodeVue,
    ModeratorLogout,
  },
  data () {
    return {
      dynamicLink: '',
    }
  },
  watch: {
    selectedSession: {
      handler(newSession) {
        if (newSession && newSession.listOfSessionVotings?.length > 0) {
          this.generateDynamicLink()
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('users', [
      'isAdmin',
      'isModerator',
    ]),
    ...mapState('sessionVoting', [
      'sessionVotingQuestions',
    ]),
    ...mapGetters('sessionVoting', [
      'hasVotingQuestions',
    ]),
    ...mapGetters('events', [
      'eventConfigLogoImageUrl',
    ]),
    selectedSessionId () {
      return parseInt(this.$route.query.session_id)
    },
    selectedSession () {
      for (const question of this.sessionVotingQuestions) {
        const session = question.listOfSessions.find(session => session.id === this.selectedSessionId)
        if (session) {
          return session
        }
      }
      return {}
    },
    logoUrl () {
      return  this.eventConfigLogoImageUrl
    },
    isAuthorized () {
      return this.isAdmin || this.isModerator
    },
  },
  methods: {
    ...mapActions('sessionVoting', [
      'getSessionVotingQuestions',
    ]),
    goToSessionVoting (sessionVoting) {
      console.log(sessionVoting.id)
    },
    votingDateFormatted (date) {
      return dayjs(date).tz("Asia/Seoul").format('MMMM DD')
    },
    formattedTimeString (date) {
      return dayjs(date).tz('Asia/Seoul').format('HH:mm')
    },
    startVoting() {
      const votingQuestion = this.selectedSession?.listOfSessionVotings[0]
      this.$router.push({name: 'ModeratorQuestions', query: {session_id: this.selectedSessionId, session_voting_id: votingQuestion.id}})
    },
    goToModeratorHome () {
      this.$router.push({ name: 'Moderator' })
    },
    async generateDynamicLink () {
      if (!this.selectedSession || !this.selectedSession.listOfSessionVotings || this.selectedSession.listOfSessionVotings.length === 0) {
        return
      }
      const votingQuestion = this.selectedSession?.listOfSessionVotings[0]
      const link = await DynamicLinkHelper.getVotingDynamicLink(
          this.selectedSessionId,
          votingQuestion.id
        )
      this.dynamicLink = link
    },
  },
  mounted () {
    this.$emit('update:layout', 'empty-page')
    if (this.sessionVotingQuestions.length === 0) {
      this.getSessionVotingQuestions()
    }
  },
  beforeDestroy () {
    this.$emit('update:layout', 'default-layout')
  },
}
</script>
